export const columns = [
  {
    accessorKey: "serialNumber",
    header: "Serial #",
    size: 150,
  },
  {
    accessorKey: "registrationNumber",
    header: "Vehicle",
    size: 140,
  },
  { accessorKey: "driverName", header: "Driver", size: 150 },
  {
    accessorKey: "vehicleType",
    header: "Type",
    size: 130,
  },
  { accessorKey: "vehicleStatus", header: "Status", size: 130 },
  {
    accessorKey: "weight",
    header: "Weight",
    size: 140,
    accessorFn: (row: any) => ` ${row.weight} ${row.weightUnit || "KG"}`,
  },
  {
    accessorKey: "paymentTypes",
    header: "Type of Payments",
    size: 220,
    accessorFn: (row: any) => ` ${row.paymentTypes || " "}`,
  },
  { accessorKey: "totalPayment", header: "Total Payment", size: 200 },
  { accessorKey: "sTaxAmount", header: "Tax Amount", size: 200 },
  { accessorKey: "netAmount", header: "Total Net Amount", size: 200 },
  {
    accessorKey: "totalPaymentReceived",
    header: "Payment Received",
    size: 230,
  },
  { accessorKey: "paymentStatus", header: "Payment Status", size: 220 },
  {
    accessorKey: "consignmentType",
    header: "Consignment ",
    size: 180,
  },
  {
    accessorKey: "gdNumber",
    header: "GD#",
    size: 130,
    accessorFn: (row: any) => ` ${row.gdNumber || " "}`,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 150,
    accessorFn: (row: any) => ` ${row.remarks || " "}`,
  },
  {
    accessorKey: "actionButtons",
    header: "Actions",
    size: 210,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
];
